var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMyAddresses = function SvgMyAddresses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0a7.485 7.485 0 00-7.485 7.485c0 4.34 5.048 10.258 6.853 12.235a.854.854 0 001.264 0c1.805-1.977 6.853-7.896 6.853-12.235A7.485 7.485 0 0010 0zm.016 19.159h-.033C8.427 17.453 3.348 11.57 3.348 7.485A6.66 6.66 0 0110 .833a6.659 6.659 0 016.652 6.652c0 4.086-5.079 9.968-6.636 11.674z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.167A3.337 3.337 0 006.667 7.5 3.337 3.337 0 0010 10.833 3.337 3.337 0 0013.334 7.5 3.337 3.337 0 0010 4.167zM10 10a2.503 2.503 0 01-2.5-2.5C7.5 6.121 8.621 5 10 5s2.5 1.121 2.5 2.5S11.38 10 10 10z",
    fill: "#333"
  })));
};
export default SvgMyAddresses;